function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import React, { PureComponent } from "react";
import { AUTH_BACK_LINK, AUTH_PAGE_CONFIG, COOKIE_POLICY, COOKIE_POLICY_URL, FREQUENTLY_ASKED_QUESTIONS, INSTALLATION_GUIDE, PRIVACY_POLICY, PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS, TERMS_AND_CONDITIONS_URL, WRITE_TO_US_ENABLED } from "@config/constants";
import { openModal, openWriteToUs } from "@common/actions";
import PrismicClient from "@common/utils/prismic";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AuthenticationFooterMenu from "./AuthenticationFooterMenu";
export var AuthenticationFooter = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(AuthenticationFooter, PureComponent);
    var _super = _create_super(AuthenticationFooter);
    function AuthenticationFooter(props) {
        _class_call_check(this, AuthenticationFooter);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasGuide: false
        };
        return _this;
    }
    _create_class(AuthenticationFooter, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var prismicData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!PrismicClient.hasPrismic()) return [
                                    2
                                ];
                                return [
                                    4,
                                    PrismicClient.getAppGuide()
                                ];
                            case 1:
                                prismicData = _state.sent();
                                if (!isEmpty(prismicData)) {
                                    _this.setState({
                                        hasGuide: true
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, hasBackLink = _this_props.hasBackLink, i18n = _this_props.i18n, _$openModal = _this_props.openModal, _$openWriteToUs = _this_props.openWriteToUs, screenType = _this_props.screenType, history = _this_props.history;
                // Why is the backlink in the fucking footer with position absolute???
                var backLinkTemplate = hasBackLink ? /*#__PURE__*/ _jsx("a", {
                    className: "back-link",
                    href: AUTH_BACK_LINK,
                    children: /*#__PURE__*/ _jsxs(Button, {
                        classes: {
                            label: "ux-button-label"
                        },
                        className: "button-no-background no-border white-text raised half-width float-left pointer",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon icon-keyboard-arrow-right"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "label",
                                children: i18n.common.back
                            })
                        ]
                    })
                }) : null;
                return screenType ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        screenType.web && backLinkTemplate,
                        /*#__PURE__*/ _jsxs("div", {
                            className: "authentication-footer-component".concat(hasBackLink ? "" : " no-back-button"),
                            children: [
                                !screenType.web && backLinkTemplate,
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "help-buttons-group",
                                    children: [
                                        screenType.web && /*#__PURE__*/ _jsxs(Button, {
                                            classes: {
                                                label: "ux-button-label lowercase"
                                            },
                                            onClick: function() {
                                                return _$openModal(FREQUENTLY_ASKED_QUESTIONS);
                                            },
                                            className: "button-no-background white-text center-vertical raised half-width float-left pointer",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-help"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "label",
                                                    children: i18n.common.help
                                                })
                                            ]
                                        }),
                                        WRITE_TO_US_ENABLED && /*#__PURE__*/ _jsxs(Button, {
                                            classes: {
                                                label: "ux-button-label lowercase"
                                            },
                                            onClick: _$openWriteToUs,
                                            className: "button-no-background white-text center-vertical raised half-width float-left pointer",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-contact-us"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "label",
                                                    children: i18n.common.mailUs
                                                })
                                            ]
                                        }),
                                        this.state.hasGuide && screenType.web && /*#__PURE__*/ _jsxs(Button, {
                                            classes: {
                                                label: "ux-button-label lowercase"
                                            },
                                            onClick: function() {
                                                return _$openModal(INSTALLATION_GUIDE, {
                                                    setPostLoginModalOpened: function() {
                                                        return null;
                                                    },
                                                    isModal: true
                                                });
                                            },
                                            className: "button-no-background white-text center-vertical raised half-width float-left pointer",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon apps-icon-white"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "label",
                                                    children: i18n.common.apps
                                                })
                                            ]
                                        }),
                                        !screenType.web && /*#__PURE__*/ _jsx(AuthenticationFooterMenu, {})
                                    ]
                                }),
                                screenType.web && /*#__PURE__*/ _jsxs("div", {
                                    className: "info-buttons-group",
                                    children: [
                                        !isEmpty(AUTH_PAGE_CONFIG.SERVICE_INFO_URL) && /*#__PURE__*/ _jsx(Button, {
                                            classes: {
                                                label: "ux-button-label lowercase"
                                            },
                                            onClick: function() {
                                                return window.open(AUTH_PAGE_CONFIG.SERVICE_INFO_URL, "_blank");
                                            },
                                            className: "button-no-background terms-button white-text center-vertical raised half-width float-left pointer",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "label",
                                                children: i18n.authentication.serviceInformation
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            classes: {
                                                label: "ux-button-label lowercase"
                                            },
                                            onClick: function() {
                                                return !isEmpty(TERMS_AND_CONDITIONS_URL) ? window.open(TERMS_AND_CONDITIONS_URL, "_blank") : _$openModal(TERMS_AND_CONDITIONS, {
                                                    title: i18n.termsAndConditions.title,
                                                    text: i18n.termsAndConditions.text
                                                });
                                            },
                                            className: "button-no-background terms-button white-text center-vertical raised half-width float-left pointer",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "label",
                                                children: i18n.authentication.terms
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            classes: {
                                                label: "ux-button-label lowercase"
                                            },
                                            onClick: function() {
                                                return !isEmpty(PRIVACY_POLICY_URL) ? window.open(PRIVACY_POLICY_URL, "_blank") : _$openModal(PRIVACY_POLICY, {
                                                    title: i18n.privacyPolicy.title,
                                                    text: i18n.privacyPolicy.text
                                                });
                                            },
                                            className: "button-no-background terms-button white-text center-vertical raised half-width float-left pointer",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "label",
                                                children: i18n.privacyPolicy.title
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            classes: {
                                                label: "ux-button-label lowercase"
                                            },
                                            onClick: function() {
                                                return !isEmpty(COOKIE_POLICY_URL) ? window.open(COOKIE_POLICY_URL, "_blank") : _$openModal(COOKIE_POLICY, {
                                                    title: i18n.cookiePolicy.title,
                                                    text: i18n.cookiePolicy.text
                                                });
                                            },
                                            className: "button-no-background terms-button white-text center-vertical raised half-width float-left pointer",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "label",
                                                children: i18n.cookiePolicy.title
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : null;
            }
        }
    ]);
    return AuthenticationFooter;
}(PureComponent);
var mapStateToProps = function(param) {
    var screenType = param.screenType;
    return {
        screenType: screenType
    };
};
export default withRouter(connect(mapStateToProps, {
    openModal: openModal,
    openWriteToUs: openWriteToUs
})(AuthenticationFooter));
